import React from 'react';
import {withRouter} from 'react-router-dom';

const LAST_NON_QUALITY_ROUTE_KEY = 'bedrock.lastNonQualityRoute';
const LOCKED_QUERY_KEY = 'locked';

const isLockedSearch = search => {
  try {
    const value = new URLSearchParams(search || '').get(LOCKED_QUERY_KEY);
    return value === '1' || value === 'true';
  } catch (e) {
    return false;
  }
};

const getReturnTo = locationState => {
  if (locationState && typeof locationState.returnTo === 'string' && locationState.returnTo.trim()) {
    return locationState.returnTo;
  }
  try {
    const saved = sessionStorage.getItem(LAST_NON_QUALITY_ROUTE_KEY);
    if (saved && saved.trim()) return saved;
  } catch (e) {
    // ignore
  }
  return '/timesheet';
};

function QualityIssueThankYouPage(props) {
  const state = (props.location && props.location.state) || {};
  const returnTo = getReturnTo(state);
  const submitted = state.submitted === true || !!state.hdCaseNum;
  const activeTab = state.activeTab || 'ncr';
  const search = props.location?.search || '';
  const locked = isLockedSearch(search);

  const handleReturn = () => props.history.push(returnTo);
  const handleCreateAnother = () =>
    props.history.push({
      pathname: `/quality-issue-form/${activeTab}`,
      search,
      state: {returnTo}
    });

  return (
    <div className="quality-issue-thank-you-page">
      <div className="thankyou-card">
        <div className="thankyou-header">
          {submitted ? (
            <>
              <h2 className="title">Thank you for your submission.</h2>
              <p className="subtitle">
                {locked
                  ? 'Your quality issue has been received.'
                  : 'Your quality issue has been received. You can return to Bedrock to continue your work.'}
              </p>
            </>
          ) : (
            <>
              <h2 className="title">Quality issue form closed.</h2>
              <p className="subtitle">
                {locked
                  ? 'No submission was made. You can create another quality issue.'
                  : 'No submission was made. You can return to Bedrock or create another quality issue.'}
              </p>
            </>
          )}
        </div>

        <div className="thankyou-body">
          {(submitted && (state.formType || state.hdCaseNum)) && (
            <div className="meta">
              {state.formType && (
                <div>
                  <strong>Form</strong>: {state.formType}
                </div>
              )}
              {state.hdCaseNum && (
                <div>
                  <strong>Reference</strong>: {state.hdCaseNum}
                </div>
              )}
            </div>
          )}

          <div className="thankyou-actions">
            <button className="btn btn-default" onClick={handleCreateAnother}>
              Create another quality issue
            </button>
            {!locked && (
              <button className="btn btn-primary" onClick={handleReturn}>
                Return to Bedrock
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(QualityIssueThankYouPage);


